const EARTH_RADIUS_KM = 6371;

// Coordinates reach the front in two shapes: hotels carry lat/lon as strings
// (numeric columns serialized as text), positions carry them as numbers.
const toNumber = (value) => {
  // 0 is a legitimate latitude/longitude, so only absent values are rejected.
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const parsed = typeof value === 'number' ? value : parseFloat(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const toRadians = (degrees) => (degrees * Math.PI) / 180;

export const toCoordinates = (point) => {
  // Same alias chain as effectiveEndPosition's own distance helper: positions
  // carry lat/lon, city relations latitude/longitude, map components lng — and
  // an effective end position can be any of the three (KD-3635).
  const lat = toNumber(point?.lat ?? point?.latitude);
  const lon = toNumber(point?.lon ?? point?.lng ?? point?.longitude);
  return lat === null || lon === null ? null : { lat, lon };
};

// Great-circle distance in kilometers, or null when either point has no usable
// coordinates. Haversine, same formula as the proximity queries on the API side.
export const distanceInKm = (from, to) => {
  const start = toCoordinates(from);
  const end = toCoordinates(to);

  if (!start || !end) {
    return null;
  }

  const deltaLat = toRadians(end.lat - start.lat);
  const deltaLon = toRadians(end.lon - start.lon);

  const a =
    Math.sin(deltaLat / 2) ** 2 +
    Math.cos(toRadians(start.lat)) *
      Math.cos(toRadians(end.lat)) *
      Math.sin(deltaLon / 2) ** 2;

  return 2 * EARTH_RADIUS_KM * Math.asin(Math.min(1, Math.sqrt(a)));
};
